export const isFirstVisit = () => {
  let _isFirstVisit = localStorage.getItem(`_isFirstVisit`)
  if (_isFirstVisit === null) {
    return true
  }
  else {
    return false
  }
}

export const setFirstVisit = () => {
  localStorage.setItem(`_isFirstVisit`, `y`)
}



// WEBPACK FOOTER //
// ./src/helper/identifyFirstVisit.js